import * as React from 'react';
import { TPAComponentProps } from '../../types';
import { CorePopoverProps } from '../internal/WixUiCoreComponents/components/CorePopover';

export interface PopoverProps
  extends TPAComponentProps,
    Omit<CorePopoverProps, 'shown'> {
  shown?: boolean;
  triggerAction?: PopoverTriggerAction;
  wiredToSiteColors?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export type { Placement as PopoverPlacement } from '../internal/WixUiCoreComponents/components/CorePopover';

export enum PopoverTriggerAction {
  hover = 'hover',
  click = 'click',
}
